import { PortableText } from "@portabletext/react";
import { urlForImage } from "@/lib/sanity";
import Image from "next/image";
import { portableTextPlusComponents } from "./portable-text-plus";
import Link from "next/link";

const ImageComponent = ({ value }) => {
  const imageLink = value?.url;
  const imageSrc = urlForImage(value).url();

  return (
    <div className="relative h-80 sm:h-96">
      {imageLink ? (
        <Link href={imageLink}>
          <a>
            <Image
              layout="fill"
              objectFit="contain"
              alt={value.alt}
              src={imageSrc}
            />
          </a>
        </Link>
      ) : (
        <Image
          layout="fill"
          objectFit="contain"
          alt={value.alt}
          src={imageSrc}
        />
      )}
    </div>
  );
};

let components = { ...portableTextPlusComponents };
components = {
  ...components,
  types: { ...components.types, image: ImageComponent },
};

export default function PortableTextPlusBlogPost({ value }) {
  return <PortableText value={value} components={components} />;
}
